import { getOKRWeightageListApi, getPerformancePreviewCompetencyApi, getReviewGoalsTimelineListApi } from '../api';

export const getReviewGoalsTimelineList = async ({ employeeId }) => {
  const res = await getReviewGoalsTimelineListApi({ employeeId });
  return res.entity;
};

export const getOKRWeightageList = async ({ employeeId, startTS, endTS, formId }) => {
  const res = await getOKRWeightageListApi({ employeeId, startTS, endTS, formId });
  return res.entity.map(({ computedData, parentGoalBasicDetails, weightage }) => ({
    ...computedData,
    parentGoalBasicDetails,
    weightage,
  }));
};

export const getPerformancePreviewCompetency = async ({ employeeId }) => {
  const res = await getPerformancePreviewCompetencyApi({ employeeId });
  return res.entity?.map(
    ({
      competencyDescription,
      competencyName,
      progress,
      competencyWeightage,
      progressPercentage,
      competencyId,
      levelUpId,
      levelUpCompetencyId,
    }) => {
      const dataSplit =
        competencyDescription &&
        competencyDescription.split('/n').map((description) => ({
          name: description,
        }));
      return {
        name: competencyName,
        progress,
        competencyWeightage,
        subCompetencies: dataSplit,
        progressPercentage,
        progressBar: {
          percentage: progressPercentage,
        },
        competencyId,
        levelUpId,
        levelUpCompetencyId,
      };
    }
  );
};
